import { render, staticRenderFns } from "./shareIconList.vue?vue&type=template&id=a5d19064&scoped=true&"
import script from "./shareIconList.vue?vue&type=script&lang=js&"
export * from "./shareIconList.vue?vue&type=script&lang=js&"
import style0 from "./shareIconList.vue?vue&type=style&index=0&id=a5d19064&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d19064",
  null
  
)

export default component.exports